export default {
  "path": "/demo/businessYouthMapDetail",
  "meta": {
    "name": "demo-地图商圈详情Demo",
    "title": "地图商圈详情Demo",
    "isComponentDoc": true,
    "category": "Business"
  }
};